import { Component, Inject, OnInit } from '@angular/core';
import { IconRegistryService } from '../utilities/icon-registry.service';
import {UiService} from '../services/ui.service';
import { UserService } from '../services/user.service';
import { StaticDataService } from '../services/static-data.service';
import { MessagingService } from '../services/messaging.service';
import { MessagingConstants } from '../models/MessagingConstants';
import { Router } from '@angular/router';
import { Globals } from '../globals';
import { ToothService } from '../services/tooth.service';
import { EnterpriseService } from '../services/enterprise.service';
import { resolvePracticeToothNumberingId } from '../models/teeth/tooth-numbering-system';
import { lastValueFrom } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  public showLeftCol: boolean = true;
  public showMidCol: boolean = true;
  public showCompactCard: boolean = false;
  public showTopHalfOfCol: boolean = true;

  numScheduleItems: number = 0;
  numTaskItems: number = 0;
  numRecentPatients: number = 0;
  panelOpenState: boolean = false;
  isTopExpanded: boolean = true;

  public expansionState: string = 'col-lg-8';

  private updateState(): void {
    if (!this.showLeftCol && !this.showMidCol)
      this.expansionState = 'col-lg-12';
    else if (this.showLeftCol && this.showMidCol)
      this.expansionState = 'col-lg-8';
    else
      this.expansionState = 'col-lg-10';
  }

  constructor(
          iconRegistryService: IconRegistryService,
          private readonly uiService: UiService,
          private readonly staticDataService: StaticDataService,
          private readonly messagingService: MessagingService,
          private readonly router: Router,
          public readonly globals: Globals,
          private readonly toothService: ToothService,
          private readonly enterpriseService: EnterpriseService,
          @Inject('Window') window: Window) {
    iconRegistryService.registerIcon('calendar', './assets/icons/icons8-calendar.svg');
    iconRegistryService.registerIcon('recent', './assets/icons/icons8-time-machine.svg');
    iconRegistryService.registerIcon('todo-list', './assets/icons/icons8-todo-list.svg');
    iconRegistryService.registerIcon('notes', './assets/icons/icons8-note.svg');
    iconRegistryService.registerIcon('description', './assets/icons/icons8-resume.svg');
    iconRegistryService.registerIcon('microscope', './assets/icons/icons8-microscope.svg');
    iconRegistryService.registerIcon('user', './assets/icons/icons8-customer.svg');
    iconRegistryService.registerIcon('eye', './assets/icons/icons8-eye.svg');
  }

  async ngOnInit() {
    window.name = "TDOSMainWindow";
    // console.log('LandingComponent ngOnInit staticDataService.isReady: ', this.staticDataService.isReady);
    // console.log('LandingComponent ngOnInit staticDataService.validValues.length: ', this.staticDataService.validValues?.length);
    // console.log('LandingComponent ngOnInit staticDataService.validValueItems.length: ', this.staticDataService.validValueItems?.length);
    if (UserService.authToken && (!this.staticDataService.isReady || this.staticDataService.validValues?.length === 0 || this.staticDataService.validValueItems?.length === 0)) {
      // console.log('LandingComponent ngOnInit refreshValues');
      await this.staticDataService.refreshValues(true, true, true, true, true);      
    }

    // TX-7151. The master teeth list is still loaded with the static-data refresh. The
      // numbering preference is resolved separately below so a later sign-in, or a landing
      // visit that finds static data already ready, still seeds the current practice.
      try {
        const teeth = await lastValueFrom(
          this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping),
        );

        // Previously guarded by `if (results[3])` against a one-element array, so this
        // assignment never ran and globals.teeth stayed empty. See TX-7151 group 9.
        if (teeth) {
          this.globals.teeth = teeth;
        }
      } catch (err) {
        console.error('Error loading teeth.', err);
      }

    // TX-7151. Resolve the practice preference on every authenticated bootstrap, not only
    // when static data needs a refresh. Draw, Document and Organizer calls later in the
    // session read Globals.currentToothNumberingId. A teeth-list failure must not skip this.
    if (UserService.authToken) {
      try {
        const clients = await lastValueFrom(this.enterpriseService.getClients());
        this.globals.currentToothNumberingId =
          resolvePracticeToothNumberingId(clients, this.globals.TDOCID);
      } catch (err) {
        // Leave Globals.currentToothNumberingId at its Universal fallback so the application
        // stays usable and shows today's notation.
        console.error('Error loading the practice tooth numbering preference.', err);
      }
    }

    this.messagingService.componentMessageCall.subscribe((response) => {
        const event = response.event;
        const eventData = response.data;

        switch (event) {
          case MessagingConstants.PATIENT_LOADED:
            this.globals.currentProviderDoctorID= null;
            this.globals.currentProviderDoctorFullName="";
            this.globals.currentProviderDoctorContactID=null;
            this.globals.currentProviderDoctorUserID=null;


            if (eventData.Process !== MessagingConstants.DO_NOT_LOAD_CASE_VIEW)
            {
              this.router.navigateByUrl('/landing/case-view');
            }
            break;
        }
      });
  }

  public handleSchedulingCardEvents(_event): void {
    this.showLeftCol = false;
    this.updateState();
  }

  public handlePatientInfoCardEvents(e): void {
    if (e === null || e === undefined) {
      this.showCompactCard = true;
      this.showMidCol = false;
    }
    else if (e.trim() === 'compact') {
      this.showCompactCard = false;
    }
    else if (e.trim() === 'expand') {
      this.showCompactCard = false;
      this.showMidCol = true;
    }

    this.updateState();
  }

  public handleCasesCardEvents(_event): void {
    this.showTopHalfOfCol = false;
  }

  public onLeftColBtn(): void {
    this.showLeftCol = true;
    this.updateState();
  }

  public onMidColBtn(): void {
    this.showMidCol = true;
    this.updateState();
  }
}
